import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"

export function displayAnonymousUserData(candidateIndex) {
  return candidateIndex
    ? `${i18n("General:Anonymous")} ${candidateIndex}`
    : i18n("General:Anonymous")
}

export function displayUserData(value, isAnonymous, candidateIndex) {
  if (isAnonymous) {
    return displayAnonymousUserData(candidateIndex)
  }

  return value != null ? value : i18n("Users:DeletedUser")
}
